import React from 'react';
import { Route } from 'react-router-dom';
export default function RouteStatus({ code, children }) {
    return (React.createElement(Route, { render: ({ staticContext }) => {
            if (staticContext)
                staticContext.statusCode = code;
            return children;
        } }));
}
